// Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.

export const WSW_DOMAIN_SUFFIX = ".workspaces-web.com";
export const WSW_FIPS_DOMAIN_SUFFIX = ".workspaces-web-fips.com";
